<template>
  <div class="conversion-files">
    <template v-if="files.length">
      <a v-for="file in files" :key="file.url" :href="file.url" target="_blank" rel="noopener noreferrer" :title="file.name" class="conversion-file">
        <i class="el-icon-download" aria-hidden="true"></i>{{ file.name }}
      </a>
    </template>
    <span v-else class="conversion-file-empty">—</span>
  </div>
</template>

<script>
export default {
  name: 'DiscountConversionFileLinks',
  props: {
    urls: { type: String, default: '' }
  },
  computed: {
    files() {
      return Array.from(new Set(this.urls.split(',').map(url => url.trim()).filter(url => /^https?:\/\//i.test(url)))).map(url => {
        const raw = url.split('?')[0].split('/').pop() || '下载文件';
        let name = raw;
        try { name = decodeURIComponent(raw); } catch (error) { name = raw; }
        return { url, name };
      });
    }
  }
};
</script>

<style scoped>
.conversion-files { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.conversion-file { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #2563eb; font-size: 13px; }
.conversion-file i { margin-right: 5px; }
.conversion-file:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
.conversion-file-empty { color: #7b8494; }
</style>
